import { isEmpty } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../../content/sections';

type HeaderContentProps = {
  cmsData?: any;
  removePaddingTop?: boolean;
};

const mapHeaderContent = ({ cmsData, removePaddingTop }: HeaderContentProps) => {
  if (isEmpty(cmsData)) {
    return null;
  }

  const { urlObject, imageObject, summary, slogan } = cmsData;

  const mappedCmsContent = {
    cta: {
      title: urlObject?.name,
      to: urlObject?.url,
    },
    image: {
      alt: imageObject?.caption,
      src: imageObject?.image?.asset?.url,
    },
    orderIndex: 1,
    removePaddingTop,
    subtitle: summary,
    title: slogan,
    type: CONTENT_SECTIONS.HEADER,
  };

  return mappedCmsContent;
};

export default mapHeaderContent;
